module.exports = __webpack_public_path__ + "static/media/deleteCircle.8068f316.svg";